// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormUser } from '~/utils/interface/user';
import { EMPTY_STRING, REG_EXP } from '~/utils/constants/common';
import { StatusEnum } from '~/utils/enum/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormUser> => {
  return yup.object().shape({
    email: yup
      .string()
      .trim()
      .test('isValidEmail', t('common_validate_invalid_email', { ns: 'common/base' }), (value) => {
        if (value && !REG_EXP.EMAIL.test(value)) return false;
        return true;
      })
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    firstName: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    lastName: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    timezone: yup.string().optional(),
    roleIds: yup.array().min(1, t('common_validate_field_required')).required(t('common_validate_field_required')),
    phoneNumber: yup
      .string()
      .trim()
      .test('phone-length', t('common_validate_invalid_phone', { ns: 'common/base' }), (value) => {
        if (!value) return true;
        const phoneNumber = value?.replace(REG_EXP.NUMBER, EMPTY_STRING);
        return REG_EXP.PHONE_NUMBER.test(phoneNumber);
      })
      .optional(),
    status: yup.string().optional(),
    countryCode: yup.string().optional(),
    address: yup.string().optional(),
    rate: yup.number().optional(),
    unitDetail: yup.string().optional(),
    city: yup.string().optional(),
    state: yup.string().optional(),
    postalCode: yup.string().optional(),
    country: yup.string().optional(),
    lat: yup.string().optional(),
    lng: yup.string().optional(),
    isDeleteAvatar: yup.boolean().optional(),
    avatarImage: yup.object().optional(),
  });
};

export const defaultValuesUserForm: IFormUser = {
  avatarImage: {},
  email: EMPTY_STRING,
  firstName: EMPTY_STRING,
  lastName: EMPTY_STRING,
  roleIds: [],
  timezone: EMPTY_STRING,
  phoneNumber: EMPTY_STRING,
  countryCode: EMPTY_STRING,
  address: EMPTY_STRING,
  unitDetail: EMPTY_STRING,
  city: EMPTY_STRING,
  state: EMPTY_STRING,
  postalCode: EMPTY_STRING,
  country: EMPTY_STRING,
  lat: EMPTY_STRING,
  lng: EMPTY_STRING,
  rate: 0,
  status: StatusEnum.ACTIVE,
};
